import React from 'react';
import Toolbar from './Toolbar';
import ToolbarCommentButtonGroup from './buttons/ToolbarCommentButtonGroup';
import useIsPublicView from '../../../utils/useIsPublicView';

type Formats = { comment?: string[] | null };

interface ReadModeToolbarProps {
  closeToolbar: () => void;
  formats?: Formats;
}

const ReadModeToolbar = ({ closeToolbar, formats }: ReadModeToolbarProps) => {
  const isPublicView = useIsPublicView();
  return (
    <Toolbar>
      {!isPublicView && (
        <ToolbarCommentButtonGroup
          existingComment={formats?.comment}
          onCommentButtonClick={closeToolbar}
        />
      )}
    </Toolbar>
  );
};

export default ReadModeToolbar;
